export type AnalyticsLoadStrategy = 'idle' | 'immediate';

export interface AnalyticsConfig {
  enabled: boolean;
  measurementId: string;
  debug: boolean;
  loadStrategy: AnalyticsLoadStrategy;
}

export interface PublicAppConfig {
  analytics: AnalyticsConfig;
}

const DEFAULT_ANALYTICS_CONFIG: AnalyticsConfig = {
  enabled: false,
  measurementId: '',
  debug: false,
  loadStrategy: 'idle',
};

export const DISABLED_ANALYTICS_CONFIG: AnalyticsConfig = {
  ...DEFAULT_ANALYTICS_CONFIG,
};

declare global {
  interface Window {
    __APP_CONFIG__?: PublicAppConfig;
  }
}

const getEnvVar = (key: string): string | undefined => {
  if (typeof process !== 'undefined') {
    // eslint-disable-next-line no-undef
    return process.env[key];
  }

  return undefined;
};

const parseBooleanEnv = (
  value: string | undefined,
  fallback: boolean
): boolean => {
  if (value === undefined) {
    return fallback;
  }

  return value.toLowerCase() === 'true';
};

const parseAnalyticsLoadStrategy = (
  value: string | undefined
): AnalyticsLoadStrategy => {
  return value === 'immediate' ? 'immediate' : 'idle';
};

export function getAnalyticsConfig(isServer: boolean): AnalyticsConfig {
  if (isServer) {
    return {
      enabled: parseBooleanEnv(getEnvVar('ANALYTICS_GA_ENABLED'), false),
      measurementId: getEnvVar('ANALYTICS_GA_MEASUREMENT_ID') || '',
      debug: parseBooleanEnv(getEnvVar('ANALYTICS_GA_DEBUG'), false),
      loadStrategy: parseAnalyticsLoadStrategy(
        getEnvVar('ANALYTICS_GA_LOAD_STRATEGY')
      ),
    };
  }

  if (typeof window === 'undefined') {
    return DEFAULT_ANALYTICS_CONFIG;
  }

  return window.__APP_CONFIG__?.analytics ?? DEFAULT_ANALYTICS_CONFIG;
}
